module.exports = __webpack_public_path__ + "static/media/play_store.5820d44a.png";